export class Microsoft365PolicyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Microsoft365EntitySelection",
            "format": ""
        },
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Microsoft365EntitySelection",
            "format": ""
        },
        {
            "name": "sharePointSites",
            "baseName": "sharePointSites",
            "type": "Microsoft365EntitySelection",
            "format": ""
        },
        {
            "name": "teams",
            "baseName": "teams",
            "type": "Microsoft365EntitySelection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365PolicyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
